<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$('#CollectionFiltersForm .sidebarBlock[data-index="4"] .facets__list .facets__item').each(function () {
  const labelText = $(this).find('label').text().toLowerCase();
  
  if (labelText.includes('boys') || labelText.includes('girls')) {
    $(this).show();
  } else {
    $(this).hide();
  }
});





